// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"abfc70145cdde315a6f5","303":"dfee5254f5c801063a55","495":"6bb79803ed11b6137ac0","826":"b3519451c5b18e2fd0a2","946":"a19380e75bff8dfad156"}[chunkId] + ".js";
};